var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scale_inputjl" }, [
    _c(
      "div",
      {
        ref: "areabox",
        staticClass: "area_box jlbox",
        style: { width: _vm.width + "px", height: _vm.height + "px" }
      },
      [
        _c(
          "table",
          {
            ref: "area",
            staticClass: "jltable",
            staticStyle: { display: "block" }
          },
          _vm._l(_vm.jlArr, function(itemjl, indexjl) {
            return _c("tr", [
              _c(
                "td",
                {
                  staticStyle: {
                    "min-width": "116px",
                    "white-space": "nowrap",
                    "vertical-align": "top",
                    height: "auto",
                    "text-align": "left"
                  }
                },
                [_vm._v(_vm._s(Object.keys(itemjl)[0]))]
              ),
              _vm._v(" "),
              _c(
                "td",
                {
                  staticStyle: {
                    "padding-left": "10px",
                    "text-align": "left",
                    "vertical-align": "top",
                    height: "auto",
                    "white-space": "pre-wrap"
                  }
                },
                [_vm._v(_vm._s(Object.values(itemjl)[0]))]
              )
            ])
          }),
          0
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }